// import React, { useState, useEffect } from "react";
// import { getFreshAccessToken } from "../../chat/api";
// import api from "../../chat/api";

// const ProjectStatusModal = ({
//   isOpen,
//   onClose,
//   projectId,
//   currentStatus,
//   onSuccess,
// }) => {
//   const [selectedStatusOption, setSelectedStatusOption] = useState("");
//   const [statusUpdateState, setStatusUpdateState] = useState("idle"); // idle | saving | saved

//   useEffect(() => {
//     if (isOpen) {
//       setSelectedStatusOption(currentStatus || "Draft");
//       setStatusUpdateState("idle");
//     }
//   }, [isOpen, currentStatus]);

//   if (!isOpen) return null;

//   const handleStatusSave = async () => {
//     if (!selectedStatusOption || selectedStatusOption === currentStatus) return;
    
//     setStatusUpdateState("saving");
//     try {
//       const token = await getFreshAccessToken();
//       await api.patch(
//         `/api/v1/rfp/folders/${projectId}/update-field/?type=status`,
//         { status: selectedStatusOption },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
      
//       setStatusUpdateState("saved");

//       // Instantly update parent UI and trigger silent background refresh
//       if (onSuccess) {
//         onSuccess(projectId, selectedStatusOption);
//       }

//       // Close modal after showing "Saved" for 2 seconds
//       setTimeout(() => {
//         onClose();
//         setStatusUpdateState("idle");
//       }, 500);
//     } catch (error) {
//       setStatusUpdateState("idle");
//       console.error("Failed to update status:", error);
//     }
//   };

//   const statusOptions = ["Draft", "Submitted", "Missed", "Win", "Lost"];

//   return (
//     <div className="fixed inset-0 z-[10000] bg-black/40 flex items-center justify-center">
//       <div className="bg-white rounded-xl shadow-lg w-[300px] py-3 px-5 relative animate-[fadeIn_0.2s_ease-in-out]">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-[#3F3F46] font-outfit text-lg font-medium">
//             Project Status
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-800 transition-colors"
//           >
//             <svg
//               width="20"
//               height="20"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <line x1="18" y1="6" x2="6" y2="18"></line>
//               <line x1="6" y1="6" x2="18" y2="18"></line>
//             </svg>
//           </button>
//         </div>
        
//         <div className="flex flex-col gap-2">
//           {statusOptions.map((opt) => (
//             <label
//               key={opt}
//               onClick={() => setSelectedStatusOption(opt)}
//               className={`flex items-center gap-3 p-2 border rounded-lg cursor-pointer transition-all ${
//                 selectedStatusOption === opt
//                   ? "border-[#8B5CF6] bg-[#F8F3FF]"
//                   : "border-gray-200 hover:border-gray-300"
//               }`}
//             >
//               <div
//                 className={`w-4 h-4 rounded-full border flex items-center justify-center ${
//                   selectedStatusOption === opt
//                     ? "border-[#8B5CF6]"
//                     : "border-gray-400"
//                 }`}
//               >
//                 {selectedStatusOption === opt && (
//                   <div className="w-2 h-2 bg-[#8B5CF6] rounded-full" />
//                 )}
//               </div>
//               <span className="font-outfit text-[15px] text-[#333]">
//                 {opt === "Win" ? "Won" : opt}
//               </span>
//             </label>
//           ))}
//         </div>
        
//         <div className="mt-5 flex justify-end">
//           <button
//             disabled={
//               !selectedStatusOption ||
//               selectedStatusOption === currentStatus ||
//               statusUpdateState !== "idle"
//             }
//             onClick={handleStatusSave}
//             className={`bg-[#8B55DD] hover:bg-[#7c4ce0] text-white font-outfit text-[13px] font-medium w-[100px] py-2 rounded-lg transition-colors flex justify-center items-center ${
//               (!selectedStatusOption ||
//                 selectedStatusOption === currentStatus ||
//                 statusUpdateState !== "idle") &&
//               "opacity-60 cursor-not-allowed"
//             }`}
//           >
//             {statusUpdateState === "saving"
//               ? "Saving..."
//               : statusUpdateState === "saved"
//               ? "Saved"
//               : "Save"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectStatusModal;
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../../chat/api";
import api from "../../chat/api";

// Fallback used only if the org's configured statuses can't be loaded — mirrors
// the historical hardcoded set so the modal still works offline/degraded.
const FALLBACK_STATUS_OPTIONS = [
  { id: "Draft", label: "Draft", color: "#CCAB29" },
  { id: "Submitted", label: "Submitted", color: "#458764" },
  { id: "Win", label: "Won", color: "#5275BA" },
  { id: "Missed", label: "Missed", color: "#CC903D" },
  { id: "Lost", label: "Lost", color: "#B55E5E" },
  { id: "Chose Not to Apply", label: "Chose Not to Apply", color: "#8B8B8B" },
];

// Statuses are stored/selected as "Win" but legacy rows may hold "Won". Map
// "Won" -> "Win" so the current status pre-selects the matching option.
const normalizeStatus = (s) => (s === "Won" ? "Win" : s);

/* Why a bid closed the way it did.
 *
 * The status says WHAT happened; this says WHY — and the why exists in no
 * document. It lives in the head of whoever is closing the project, and is
 * otherwise lost: 15 projects on this workspace have already closed with a
 * reason and every one of those reasons is gone.
 *
 * OPTIONAL, ALWAYS. Saving works with nothing selected. If closing a project
 * could fail on this field, people would stop closing projects honestly, or pick
 * whatever sits first in the list — and a miscoded reason is worse than none,
 * because it warns colleagues off winnable work.
 */
const CLOSED_STATUSES = ["Win", "Lost", "Missed", "Chose Not to Apply"];

/* A WIN GETS NO REASON LIST. Every code in the vocabulary below is a reason a
 * bid was LOST or not pursued — "failed a mandatory requirement" is nonsense on
 * a bid we won. The outcome is still recorded (it is what marks the proposal as
 * won), and the free-text note still offered, because "won on the AI
 * differentiator" is worth keeping. Only the loss codes are withheld. */
const REASON_STATUSES = ["Lost", "Missed", "Chose Not to Apply"];

/* Split, not just listed. Whether a reason carries forward is the single most
 * important thing about this vocabulary — a bid lost on price says nothing about
 * whether the next one is winnable, and surfacing it as a caution would steer a
 * team off work they should chase. Rendering all six as one flat list made that
 * distinction invisible, which is how the wrong one gets picked. */
const SIGNAL_REASONS = [
  { code: "compliance_miss", label: "Failed a mandatory requirement" },
  { code: "capability_gap", label: "We lacked a required capability" },
  { code: "past_performance_gap", label: "No comparable past work" },
  { code: "deadline_capacity", label: "Could not resource it in time" },
];

const NON_SIGNAL_REASONS = [
  { code: "price", label: "Lost on price" },
  { code: "lost_to_incumbent", label: "Incumbent advantage" },
];

const ProjectStatusModal = ({
  isOpen,
  onClose,
  projectId,
  currentStatus,
  onSuccess,
}) => {
  const normalizedCurrent = normalizeStatus(currentStatus);
  const [selectedStatusOption, setSelectedStatusOption] = useState("");
  const [statusUpdateState, setStatusUpdateState] = useState("idle"); // idle | saving | saved
  const [statusOptions, setStatusOptions] = useState(FALLBACK_STATUS_OPTIONS);
  const [loadingStatuses, setLoadingStatuses] = useState(false);
  const [reasonCodes, setReasonCodes] = useState([]);
  const [reasonNote, setReasonNote] = useState("");
  const [statusListOpen, setStatusListOpen] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setSelectedStatusOption(normalizedCurrent || "Draft");
      setStatusUpdateState("idle");
      setReasonCodes([]);
      setReasonNote("");
      // Always open on the list: a modal that opens collapsed hides the thing
      // the user came to change.
      setStatusListOpen(true);
    }
  }, [isOpen, normalizedCurrent]);

  // Load the org's enabled project statuses each time the modal opens.
  useEffect(() => {
    if (!isOpen) return;
    let active = true;
    const loadStatuses = async () => {
      const orgId = Cookies.get("selected_org_id");
      if (!orgId) return;
      if (active) setLoadingStatuses(true);
      try {
        const res = await api.get(
          `/api/v1/org/project-statuses/?organization_id=${orgId}`
        );
        const all = [
          ...(res.data?.default || []),
          ...(res.data?.custom || []),
        ].filter((s) => s.is_enabled);
        if (active && all.length) {
          setStatusOptions(
            all.map((s) => ({
              id: s.label,
              label: s.label === "Win" ? "Won" : s.label,
              color: s.color,
            }))
          );
        }
      } catch (error) {
        console.error("Failed to load project statuses:", error);
        // keep the fallback options
      } finally {
        if (active) setLoadingStatuses(false);
      }
    };
    loadStatuses();
    return () => {
      active = false;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Handles closing the modal and resetting any unsaved selection
  const handleClose = () => {
    setSelectedStatusOption(normalizedCurrent || "Draft");
    setStatusUpdateState("idle");
    setReasonCodes([]);
    setReasonNote("");
    onClose();
  };

  // Whether to ask why. Only closed outcomes have a reason worth recording —
  // moving a project to "In Progress" does not.
  // A closed outcome collapses the list and offers a note; only a LOSS or a
  // no-bid gets the reason codes.
  const isClosed = CLOSED_STATUSES.includes(selectedStatusOption);
  const asksForReason = REASON_STATUSES.includes(selectedStatusOption);

  // ONE SCREEN, ALWAYS. Appending the reason block below a 320px status list
  // pushed the modal past the viewport: the heading and the Save button were
  // both clipped, so the primary action was unreachable. Once a closed status is
  // chosen the list collapses to the choice itself, and the reason takes the
  // space the list was using. "Change" brings it back.
  const pickStatus = (label) => {
    setSelectedStatusOption(label);
    // Drop a reason chosen under a different outcome. Picking "Lost →
    // capability gap" and then switching to "Won" must not send a loss code
    // with a win, which is the nonsense this whole split exists to prevent.
    if (!REASON_STATUSES.includes(label)) setReasonCodes([]);
    if (CLOSED_STATUSES.includes(label)) setStatusListOpen(false);
  };
  const showStatusList = statusListOpen || !isClosed;

  // CHECKBOXES, NOT RADIOS. A bid rarely loses for exactly one reason — a
  // capability gap and a missing reference are usually the same story — and a
  // single choice makes someone throw away half of what they know.
  //
  // Borderless rows: six identical bordered cards read as six competing
  // decisions; a plain list reads as one question with six answers, in about
  // half the height.
  const toggleReason = (code) =>
    setReasonCodes((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]
    );

  const reasonRow = (r) => {
    const on = reasonCodes.includes(r.code);
    return (
      <button
        key={r.code}
        type="button"
        role="checkbox"
        aria-checked={on}
        onClick={() => toggleReason(r.code)}
        className={`flex w-full items-center gap-2.5 rounded-md px-2 py-[7px] text-left text-[13px] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#8B5CF6] ${
          on ? "bg-[#8B5CF6]/[0.08] font-medium text-[#18101C]" : "text-[#52525B] hover:bg-gray-50"
        }`}
      >
        <span
          aria-hidden="true"
          className={`flex h-[15px] w-[15px] flex-none items-center justify-center rounded-[4px] border-[1.5px] transition-colors ${
            on ? "border-[#8B5CF6] bg-[#8B5CF6]" : "border-gray-300"
          }`}
        >
          {on && (
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </span>
        <span className="min-w-0 truncate">{r.label}</span>
      </button>
    );
  };

  const handleStatusSave = async () => {
    if (!selectedStatusOption || selectedStatusOption === normalizedCurrent) return;

    setStatusUpdateState("saving");
    try {
      const token = await getFreshAccessToken();
      await api.patch(
        `/api/v1/rfp/folders/${projectId}/update-field/?type=status`,
        {
          status: selectedStatusOption,
          // Omitted rather than sent empty when nothing was chosen: the server
          // reads an absent reason as "not recorded", which is not the same as
          // "recorded as blank".
          ...(reasonCodes.length ? { reason_codes: reasonCodes } : {}),
          ...(reasonNote.trim() ? { note: reasonNote.trim() } : {}),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setStatusUpdateState("saved");

      if (onSuccess) {
        onSuccess(projectId, selectedStatusOption);
      }

      setTimeout(() => {
        onClose();
        setStatusUpdateState("idle");
      }, 500);
    } catch (error) {
      setStatusUpdateState("idle");
      console.error("Failed to update status:", error);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[10000] bg-black/40 flex items-center justify-center"
      onClick={handleClose} // Close modal on backdrop click
    >
      <div 
        // 360px: "Could not resource it in time" and the divider label both wrap
        // at 320. max-h + flex keeps the footer on screen on a short viewport —
        // the previous fixed layout pushed Save out of view once the reason
        // block appeared, leaving the primary action unreachable.
        className="bg-white rounded-xl shadow-lg w-[360px] max-h-[88vh] flex flex-col p-5 relative animate-[fadeIn_0.2s_ease-in-out]"
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside the modal from closing it
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[#3F3F46] font-outfit text-lg font-semibold">
            Project Status
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-700 transition-colors"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Collapsed: the chosen outcome, with a way back to the list. This is
            what keeps the modal on one screen once the reason block appears. */}
        {!showStatusList && (
          <button
            type="button"
            onClick={() => setStatusListOpen(true)}
            className="flex w-full items-center justify-between rounded-lg border border-[#8B5CF6] bg-[#8B5CF6]/[0.06] px-3 py-2.5 text-left transition-colors hover:bg-[#8B5CF6]/[0.1] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#8B5CF6]"
          >
            <span className="flex items-center gap-2.5">
              <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full border-[1.5px] border-[#8B5CF6]">
                <span className="h-2.5 w-2.5 rounded-full bg-[#8B5CF6]" />
              </span>
              <span className="font-outfit text-[15px] font-medium text-gray-900">
                {selectedStatusOption}
              </span>
            </span>
            <span className="text-[12.5px] font-medium text-[#8B5CF6]">Change</span>
          </button>
        )}

        {/* Fixed-height, scrollable area — same height while loading so the
            modal doesn't resize when statuses arrive. */}
        <div
          className={`${showStatusList ? "h-[320px]" : "hidden"} overflow-y-auto custom-scrollbar pr-1`}
        >
          {loadingStatuses ? (
            <div className="h-full flex flex-col items-center justify-center gap-2 text-[#71717A]">
              <svg
                className="animate-spin w-5 h-5 text-[#8B5CF6]"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
              </svg>
              <span className="font-outfit text-[14px]">Fetching statuses…</span>
            </div>
          ) : (
            <div className="flex flex-col gap-2.5">
              {statusOptions.map((opt) => (
                <label
                  key={opt.id}
                  onClick={() => pickStatus(opt.id)}
                  className="flex items-center justify-between p-2.5 border border-gray-200 rounded-lg cursor-pointer transition-all hover:bg-gray-50"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-[18px] h-[18px] rounded-full border-[1.5px] border-[#8B5CF6] flex items-center justify-center">
                      {selectedStatusOption === opt.id && (
                        <div className="w-2.5 h-2.5 bg-[#8B5CF6] rounded-full" />
                      )}
                    </div>
                    <span
                      className={`font-outfit text-[15px] ${
                        selectedStatusOption === opt.id
                          ? "text-gray-900 font-medium"
                          : "text-[#3F3F46]"
                      }`}
                    >
                      {opt.label}
                    </span>
                  </div>
                  <div
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: opt.color || "#8B5CF6" }}
                  />
                </label>
              ))}
            </div>
          )}
        </div>

        {isClosed && !showStatusList && (
          <div className="mt-4">
            <p className="text-[12px] font-medium uppercase tracking-wide text-[#9A93A1]">
              {asksForReason ? "Why" : "Notes"}
            </p>

            {asksForReason && (
              // One plain list. The signal split still governs what surfaces on a
              // later bid, but it is enforced server-side and does not need to be
              // narrated here — six bordered cards and a paragraph of small print
              // buried the actual choice.
              <div className="mt-1.5">
                {[...SIGNAL_REASONS, ...NON_SIGNAL_REASONS].map((r) => reasonRow(r))}
              </div>
            )}

            <input
              value={reasonNote}
              onChange={(e) => setReasonNote(e.target.value)}
              placeholder={asksForReason ? "Add a note (optional)" : "What won it? (optional)"}
              maxLength={2000}
              className="mt-2 w-full rounded-lg border border-gray-200 px-2.5 py-[7px] font-outfit text-[13px] text-[#18101C] placeholder:text-[#B0AEB8] focus:border-[#8B5CF6] focus:outline-none"
            />
          </div>
        )}

        <div className="mt-5 flex justify-end pt-4 border-t border-gray-100">
          <button
            disabled={
              !selectedStatusOption ||
              selectedStatusOption === normalizedCurrent ||
              statusUpdateState !== "idle"
            }
            onClick={handleStatusSave}
            className={`bg-[#8B5CF6] hover:bg-[#7c4ce0] text-white font-outfit text-[14px] font-medium px-8 py-2 rounded-lg transition-colors flex justify-center items-center ${
              (!selectedStatusOption ||
                selectedStatusOption === normalizedCurrent ||
                statusUpdateState !== "idle") &&
              "opacity-60 cursor-not-allowed"
            }`}
          >
            {statusUpdateState === "saving"
              ? "Saving..."
              : statusUpdateState === "saved"
              ? "Saved"
              : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectStatusModal;